<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "New Expense",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect,Loader, },
  data() {
    return {
      title: "Record Expenses",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "New Expense",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "category.name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],

      // Value from user input for adding position
      data: {
        category_id: "",
        amount: "",
      },
      itemError: "",
      amountError: "",
      PaidError:"",
      modeError:"",
      supplierError:"",
      totals: {
        date:moment(new Date()).format("YYYY-MM-DD"), 
        total: 0,
        paid: 0,
        mode: 0,
        supplier: "",
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        category_id: "",
        amount: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      }
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("expenses", ["ExpensesCart","ExpenseId","ExpenseSaveStatus", "ExpenseCategories"]),

    ...mapGetters("setting", ["PaymentOptions","ReceiptSettings","GeneralSettings"]),
    ...mapGetters("auth",["MyUserPerm"]),
    ...mapGetters("stock", ["Suppliers"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ExpensesCart ? this.ExpensesCart.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ExpensesCart ? this.ExpensesCart.length : 1;
  },
  methods: {
    ...mapActions({
      FetchExpenseCategories: "expenses/fetchExpenseCategories",
      FetchExpensesCart: "expenses/fetchExpensesCart",
      AddCart: "expenses/addExpenseCart",
      DeleteCartItem: "expenses/deleteExpenseCart",
      EditCartItems: "expenses/editExpenseCart",
      SaveExpense: "expenses/recordExpense",
      SaveExpensePrint: "expenses/recordExpensePrint",
      FetchModes: "setting/fetchPaymentOptions",
      FetchSuppliers: "stock/fetchSuppliers",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addPriceCommas(){
      this.data.amount = this.thousandSeprator(this.data.amount);
    },
    editPriceCommas(){
      this.editdata.amount = this.thousandSeprator(this.editdata.amount);
    },

    checkItem() {
      if (this.data.category_id != "") {
        this.existingItem = this.ExpensesCart.filter((item) => {
          return item.category.id == this.data.category_id;
        });
        if (this.existingItem.length) {
          this.itemError = "This Item exists already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    resetData() {
      this.data.category_id = "";
      this.data.amount = "";
    },
    resetTotals() {
      this.totals.paid = 0;
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.category_id = "";
      this.editdata.id = "";
      this.editdata.amount = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.amountError = "";
    },

    showEditModal(data) {
      this.editdata.category_id = data.category.id;
      this.editdata.name = data.category.name;
      this.editdata.id = data.id;
      this.editdata.amount = this.thousandSeprator(data.amount);
    },

    showDeleteModal(data) {
      this.deletedata.name = data.category.name;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
      this.closeModal(this.modal_id);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
      this.closeModal(this.modal_id);
    },
    saveExpense() {
      if (this.totals.mode == "") {
        this.modeError = "Payment option field is required";
        return;
      } else {
        this.modeError = "";
      }
      
      const paid = this.removeCommas(this.totals.paid);
      const total = this.removeCommas(this.totals.total);

      if (this.totals.supplier == "" && paid != 0 &&(paid < total) || this.totals.supplier == "" && paid == 0) {
        this.supplierError = "Supplier field is required";
        return;
      } else {
        this.supplierError = "";
      }
      this.SaveExpense(this.totals);
    },
    removeCommas(value) {
      return typeof value === "string" ? parseFloat(value.replaceAll(",", "")) : parseFloat(value || 0);
    },
    saveExpensePrint() {
      if (this.totals.mode == "") {
        this.modeError = "Payment option field is required";
        return;
      } else {
        this.modeError = "";
      }
      const paid = this.removeCommas(this.totals.paid);
      const total = this.removeCommas(this.totals.total);

      if ((this.totals.supplier == "" || this.totals.supplier == "") && total>paid ) {
        this.supplierError = "Supplier field is required";
        return;
      } else {
        this.supplierError = "";
      }
      this.SaveExpensePrint(this.totals);
    },
    addToCart() {
      if (this.data.category_id == "") {
        this.itemError = "Category is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.amount == "") {
        this.amountError = "Unit Price Field is required";
        return;
      } else {
        this.amountError = "";
      }
      if (this.existingItem.length) {
        this.itemError = "This Item exists already please";
        return;
      } else {
        this.itemError = "";
      }
      this.AddCart(this.data);
      this.resetData();
    },
    paidCommas(){
      this.totals.paid = this.thousandSeprator(this.totals.paid);
    },
    
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetErrors();
      });
    },

    setDefaultMode(){
      let defaultop = this.PaymentOptions?this.PaymentOptions:[].filter((mode)=>{
            return mode.default == 1;
        })
        this.totals.mode = defaultop[0]?defaultop[0].id:0;
    },
    resetmodeError() {
      this.modeError = "";
    },
    resetPaidError() {
      this.PaidError = "";
    },
    
  },
  updated(){
    let total_amount = 0;
    if(this.ExpensesCart){      
        this.ExpensesCart.forEach((item)=>{
          total_amount = total_amount+parseInt(item.amount);      
      });
      this.totals.total = total_amount;
    }
  },

  watch: {
    ExpensesCart(newValue){
      if(newValue == true){
        this.FetchExpensesCart();
      }
    },
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          this.resetTotals();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    ExpenseId(newValue) {
        window.open(
          `https://${window.location.host}/receipts/expensecreditorsreceipt.php?id=${btoa(newValue)}`
        );
    },
  },
  created() {
    this.FetchExpenseCategories();
    this.FetchExpensesCart();
    this.FetchSuppliers();
    this.FetchModes();
    this.FetchGeneralSettings();
    setTimeout(()=> {
         this.setDefaultMode();
    }, 3000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Items in Cart</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="ExpensesCart ? ExpensesCart : []"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(total_price)="data">
                  {{
                    data.item.unitprice
                        ? thousandSeprator(data.item.amount * data.item.amount)
                        : 0
                  }}
                </template>

                <template #cell(amount)="data">
                  {{ data.item.amount ? thousandSeprator(data.item.amount) : 0 }}
                </template>
                

                <template #cell(actions)="data">
                  <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-item-modal
                      class="m-2"
                      @click="showEditModal(data.item)"
                  ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                      v-b-modal.delete-item-modal
                      variant="danger"
                      size="sm"
                      @click="showDeleteModal(data.item)"
                  ><i class="fa fa-trash"></i></b-button
                  >
                </template>
              </b-table>

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="!ExpensesCart" />
            <div class="row" v-if="totals.total > 0">
              <div class="col-12 text-center mt-4">
                <h4>
                  <strong
                  >TOTAL:
                    {{
                      thousandSeprator(totals.total)
                    }}/=</strong
                  >
                </h4>
              </div>
            </div>

            <b-form v-if="totals.total > 0">              
              <div class="row">                
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Amount Paid <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="totals.paid"
                      ref="Amountpaid"
                      @input="paidCommas()"
                      @keyup.enter="saveExpense()"
                      min="0"
                    />
                  </div>
                  <div class="text-danger" v-if="PaidError">
                    <em>{{ PaidError }}</em>
                  </div>
                </div>
                
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Payment Method <span class="text-danger">*</span></label>
                    <model-list-select
                      :list="PaymentOptions ? PaymentOptions : []"
                      v-model="totals.mode"
                      option-value="id"
                      option-text="mode"
                      placeholder="Select Method"
                      @input="resetmodeError()"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="modeError">
                    <em>{{ modeError }}</em>
                  </div>
                </div>
                
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Supplier </label>
                    <model-list-select
                      :list="Suppliers ? Suppliers : []"
                      v-model="totals.supplier"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Supplier"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="supplierError">
                    <em>{{ supplierError }}</em>
                  </div>
                </div>

                <div class="form-group col-md-4">
                  <label>Date <span class="text-danger">*</span></label>
                  <input
                      type="date"
                      class="form-control"
                      v-model="totals.date"
                      placeholder="Enter Date"
                      v-limit-future-date
                  />
                </div>
                <div v-if="ExpenseSaveStatus" class="col-md-4 mt-4">
                  <b-button variant="primary" class="pull-center" disabled
                  ><i class="fa fa-check"></i> Saving 
                    <b-spinner
                        variant="light"
                        label="Spinning"
                    ></b-spinner>
                  </b-button>
                </div>
                <div v-if="!ExpenseSaveStatus" class="col-md-4 mt-4">
                  <b-button variant="primary" class="pull-center mr-2" @click="saveExpense()"
                  ><i class="fa fa-check"></i> Save Expense
                  </b-button>
                  
                </div>
                <div v-if="!ExpenseSaveStatus" class="col-md-4 mt-4">
                  <b-button variant="primary" class="pull-center " @click="saveExpensePrint()"
                  ><i class="fa fa-check"></i> Save & Print
                  </b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <form action="">

              <div class="form-group mb-3">
                <label>Expense Item <span class="text-danger">*</span></label>
                <model-list-select
                    :list="ExpenseCategories ? ExpenseCategories : []"
                    v-model="data.category_id"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Product"
                    @input="resetErrors(), checkItem()"
                >
                </model-list-select>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Amount <span class="text-danger">*</span></label>
                <input
                    type="text"
                    class="form-control"
                    step="any"
                    v-model="data.amount"
                    @input="resetErrors(),addPriceCommas()"
                    placeholder="Enter Unit Price"
                    @keyup.enter="addToCart()"
                />
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
              </div>
             
              
              <div class="form-group text-center">
                <b-button
                    @click="addToCart()"
                    variant="primary"
                ><i class="fa fa-plus"></i> Add
                  <b-spinner
                      v-if="ExpenseSaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal id="edit-item-modal" class="text-primary" hide-footer @hidden="resetEdit()">
      <template #modal-title>
        Edit Item {{ editdata.name }}</template
      >
      
      <div class="form-group mb-3">
        <label>Amount</label>
        <input type="text" class="form-control" step="any" v-model="editdata.amount" @input="editPriceCommas()"/>
      </div>
      
      
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
              v-if="ExpenseSaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal id="delete-item-modal" class="text-danger" hide-footer @hidden="resetDeleteItem">
      <template #modal-title> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-danger"
            @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
              v-if="ExpenseSaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary, .page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>